import React from "react";

const SocialReviewBadges = () => {
  return (
    <div className={"flex items-center gap-10 justify-center max-lg:p-[3px]"}>
      <div className="lg:flex-1 flex items-center justify-center">
        <img
          src="/assets/images/subscription-competitions/trust-logo.svg"
          alt="trust"
          width={164}
          height={78}
          className="w-full object-contain max-w-[100px] lg:max-w-[168px] trust-logo"
        />
      </div>
      <div className="lg:flex-1 flex items-center justify-center">
        <img
          src="/assets/images/subscription-competitions/feefo-logo.svg"
          alt="feefo"
          width={164}
          height={78}
          className="w-full object-contain max-w-[100px] lg:max-w-[168px] trust-logo"
        />
      </div>
    </div>
  );
};

export default SocialReviewBadges;
